import { render, staticRenderFns } from "./PopupApprovalProcess.vue?vue&type=template&id=1222a17c&scoped=true"
import script from "./PopupApprovalProcess.vue?vue&type=script&lang=js"
export * from "./PopupApprovalProcess.vue?vue&type=script&lang=js"
import style0 from "./PopupApprovalProcess.vue?vue&type=style&index=0&id=1222a17c&prod&lang=scss"
import style1 from "./PopupApprovalProcess.vue?vue&type=style&index=1&id=1222a17c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1222a17c",
  null
  
)

export default component.exports